export default __webpack_public_path__ + "static/media/sofya.bd2832ea.jpg";